import {
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { ITableColumn } from "components/interfaces";
import { formatNumberToMonetary } from "utils";
import { HeadTable, Row } from "./";

export interface SubTableProps {
  /** Classes customizadas para tabela. */
  classes?: {
    expandedTable?: string;
    headerRow?: string;
    row?: string;
  };
  /** Define se a tabela será exibida ou colapsada/escondida. */
  open: boolean;
  /** Propriedade colspan da célula que conterá a tabela secundária. É medido por número de colunas. */
  colSpan: number;
  /** Quantidade de colunas em branco que serão exibidas antes das colunas. */
  blankColumns: number;
  /** Colunas da tabela. */
  columns: ITableColumn[];
  /** Dados que serão exibidos na linha do cabeçalho */
  headerRow: any[];
  /** Linhas restantes do corpo da tabela */
  rows: any[];
}

/** Tabela secundária que será adicinada como detalhe de uma linha da tabela principal.
 * @category Components
 */
const SubTable = ({
  classes,
  open,
  colSpan,
  blankColumns,
  columns,
  headerRow,
  rows,
}: SubTableProps) => {
  const blankCell =
    blankColumns > 0 && columns
      ? [{ dataKey: "", label: "", colSpan: blankColumns }]
      : [];

  function renderHeadColumns() {
    const blankColumns = renderBlankCell();
    const updatedColumns = columns.map((col) => {
      let label = headerRow[col.dataKey];
      if (col.monetary) label = formatNumberToMonetary(Number(label));
      col.label = label;
      return col;
    });

    return [...blankColumns, ...updatedColumns];
  }

  function renderBlankCell() {
    const cells: any = [];
    for (let i = 0; i < blankColumns; i++)
      cells.push({ dataKey: `blanck-${i}`, label: "" });
    return cells;
  }

  return (
    <TableRow>
      <TableCell style={{ padding: 0 }} colSpan={colSpan}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Table className={classes?.expandedTable}>
            <HeadTable
              className={classes?.headerRow}
              columns={renderHeadColumns()}
              style={{ paddingTop: 0 }}
            />
            <TableBody>
              {rows.map((row, index) => {
                return (
                  <Row
                    key={`subtable-row-${index}`}
                    className={classes?.row}
                    columns={[...blankCell, ...columns]}
                    row={row}
                  />
                );
              })}
            </TableBody>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

SubTable.defaultProps = {
  classes: {
    expandedTable: "",
    headerRow: "",
    row: "",
  },
};

export default SubTable;
